import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../images/Embarque Logo.png";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">

      {/* Logo */}

      <Link to="/" className="logo-link">

  <div className="logo-section">

    <img
      src={logo}
      alt="logo"
    />

    <div>
      <h2>EMBARQUE</h2>
      <span>Services</span>
    </div>

  </div>

</Link>

      {/* Toggle Button */}

      <div
        className="toggle-btn"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? "✕" : "☰"}
      </div>

      {/* Nav Links */}

      <ul className={menuOpen ? "nav-links active" : "nav-links"}>

        <li onClick={closeMenu}>
          <Link to="/">HOME</Link>
        </li>

        <li className="dropdown">

          <span className="service-text">
            SERVICES ⌄
          </span>

          <ul className="dropdown-menu">

            <li onClick={closeMenu}>
              <Link to="/washing-machine-service">
                Washing Machine Service
              </Link>
            </li>

            <li onClick={closeMenu}>
              <Link to="/ac-service">
                AC Service
              </Link>
            </li>

            <li onClick={closeMenu}>
              <Link to="/fridge-service">
                Fridge Service
              </Link>
            </li>

            <li onClick={closeMenu}>
              <Link to="/microwave-service">
                Microwave Oven Service
              </Link>
            </li>

            <li onClick={closeMenu}>
              <Link to="/tv-service">
                TV Service
              </Link>
            </li>

            <li onClick={closeMenu}>
              <Link to="/water-heater-service">
                Water Heater Service
              </Link>
            </li>

            <li onClick={closeMenu}>
              <Link to="/water-purifier-service">
                Water Purifier Service
              </Link>
            </li>

          </ul>

        </li>

        <li onClick={closeMenu}>
          <Link to="/about">ABOUT</Link>
        </li>

        <li onClick={closeMenu}>
          <Link to="/contact">CONTACT</Link>
        </li>

      </ul>

      {/* Contact */}
<div className="contact-section">

  <p>
    Have any questions?
  </p>

  <a
    href="tel:+919363929984"
    className="phone-link"
  >
    +91 93639 29984
  </a>

</div>

    </nav>
  );
}

export default Navbar;